import { useEffect, useState } from 'react'
import { useTheme } from '@/context/ThemeContext'
import Hero from '@/components/Frontside/Hero'
import ProjectsGrid from '@/components/Frontside/ProjectsGrid'
import Navigation from '@/components/Frontside/Navigation'
import Footer from '@/components/Frontside/Footer'
import { useScrollSpy } from '@/hooks/useScrollSpy'

function Frontside() {
  const { setTheme } = useTheme()
  const [projectSearch, setProjectSearch] = useState('')

  const sections = [
    { id: 'hero', name: 'Christian Fiebig' },
    { id: 'projects', name: 'Selected Projects' },
  ]

  const currentSection = useScrollSpy(sections)

  useEffect(() => {
    setTheme('light')
  }, [setTheme])

  return (
    <div className="frontside-page bg-background text-foreground flex flex-col min-h-screen">
      <Navigation
        currentSection={currentSection}
        searchValue={projectSearch}
        onSearchChange={setProjectSearch}
      />
      <main className="flex-1 w-full">
        <div id="hero" data-section="hero">
          <Hero />
        </div>
        <div data-section="projects">
          <ProjectsGrid searchQuery={projectSearch} />
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Frontside
